import { h as c } from "vue";
const a = c("svg", {
  viewBox: "0 0 100 100",
  class: "line-icon"
}, c("path", {
  d: "M80.2,55.5H21.4c-2.8,0-5.1-2.5-5.1-5.5l0,0c0-3,2.3-5.5,5.1-5.5h58.7c2.8,0,5.1,2.5,5.1,5.5l0,0C85.2,53.1,82.9,55.5,80.2,55.5z"
}));
export {
  a as default
};
